import { Component, ElementRef, EventEmitter, HostListener, Input, Output, QueryList, ViewChildren, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { stateOrCountryDropdownAnimation } from 'src/app/shared/reusable-animations/card-estimate-drawer-animations'

@Component({
    selector: 'app-custom-select-input',
    templateUrl: './custom-select-input.component.html',
    styleUrls: ['./custom-select-input.component.scss'],
    animations: [stateOrCountryDropdownAnimation],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomSelectInputComponent),
            multi: true
        }],
    standalone: false
})
export class CustomSelectInputComponent implements ControlValueAccessor {
  @ViewChildren('inputContainer') inputContainerElement: QueryList<ElementRef>
  @HostListener('document:click', ['$event']) onClickOutside(event: MouseEvent) {
    const targetElement = event.target as HTMLElement
    if (this.inputContainerElement) {
      let clickedInside = false

      this.inputContainerElement.forEach((container) => {
        if (container.nativeElement.contains(targetElement)) {
          clickedInside = true
        }
      })
      if (!clickedInside) {
        this.showDropdown = false
      }
    }
  }
  @Output() focusEvent: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>()
  @Input() options: { name: string, code: string }[] = []
  @Input() placeholder: string = ''
  @Input() formControlName: string
  @Input() set activeDropdown(fieldName: string | null) {
    if (fieldName !== this.formControlName) {
      this.showDropdown = false
    }
  }

  displayValue: string = ''

  filteredOptions: { name: string, code: string }[] = []

  showDropdown: boolean = false

  private onChange: (value: any) => void = () => {}
  private onTouched: () => void = () => {}

  writeValue(value: string): void {
    if (value) {
      const selectedOption = this.options.find(option => option.code === value)
      this.displayValue = selectedOption ? selectedOption.name : ''
    } else {
      this.displayValue = ''
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  // setDisabledState?(isDisabled: boolean): void {
  //   // Handle setting a disabled state if needed.
  // }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement
    this.displayValue = input.value
    this.showDropdown = true
    this.filterOptions(input.value)
  }

  filterOptions(searchText: string): void {
    if (!searchText) {
      this.filteredOptions = this.options
      return
    }
    const lowerSearch = searchText.toLowerCase()
    this.filteredOptions = this.options.filter(option =>
      option.name.toLowerCase().startsWith(lowerSearch) || option.code.toLowerCase().startsWith(lowerSearch)
    )

    if (this.filteredOptions.length === 1 && this.filteredOptions[0].name.toLowerCase() === lowerSearch) {
      this.selectOption(this.filteredOptions[0])
    }
  }

  onFocus(event: FocusEvent): void {
    this.focusEvent.emit(event)
    this.showDropdown = true
    this.filterOptions(this.displayValue)
    this.onTouched()
  }

  selectOption(option: { name: string, code: string }): void {
    this.displayValue = option.name
    this.onChange(option.code)
    this.showDropdown = false
  }

  onBlur(): void {
    setTimeout(() => {
      this.showDropdown = false
    }, 200)
  }
}
